export const m = {
  EnterID: "Cliquez pour entrer l'identifiant de Tada ",
  "select-specifications":
    "Cliquez pour sélectionner les spécifications de recharge",
  "check-account": "Vérifiez le compte de recharge",
  whatID: "Qu'est-ce que l'identifiant de Tada?",
  getID: "Entrez l'identifiant de Tada",
  maskgetID: " Entrez l'identifiant de Tada",
  "toastTips-format-error": "Format d'entrée incorrect",
  "toastTips-no-exist": "Cet identifiant n'existe pas",
  toastTipsPlease: "Veuillez d'abord vérifier le compte de recharge",
  "common-problem": "Problèmes communs",
  "transaction-succeeded": "Transaction réussie",
  "transaction-failed": "Transaction échouée",
  "transaction-cancel": "Transaction annulée",
  "whether-account": "1.Comment vérifier si c'est crédité après la recharge?",
  "answer-whether-account":
    "Après la recharge, vous pouvez revenir à [Moi] - [Portefeuille] dans l'application pour vérifier les diamants",
  "no-account":
    "2.Et comment faire si le compte n'est pas crédité après la recharge?",
  "answer-no-account":
    "Veuillez soumettre vos questions dans [Messages] - [Messages officiels] - [Commentaires et aide] de l'application, et fournir les informations suivantes, notre service client vous aidera.",
  "recharge-money": "1. Montant de la recharge et identifiant du compte",
  "recharge-time": "2. Heure et date de recharge",
  "recharge-shot": "3. Capture d'écran du paiement réussi",
  "recharge-wrong":
    "3.Que dois-je faire si je recharge le compte incorrect ou le montant incorrect ?",
  "answer-recharge-wrong":
    "Avant d'entrer le mot de passe de paiement, veuillez vous assurer de bien confirmer l'identifiant du compte de recharge et les informations sur le montant de la recharge avant d'effectuer un achat. Le montant de recharge incorrect ne peut pas être remboursé. Pour un compte erroné, vous pouvez essayer de contacter l'utilisateur réel et négocier avec lui s'il peut compenser votre charge.",
  refund: "4.Remboursement",
  "answer-refund":
    "Désolé! Tada ne supporte pas actuellement aucune forme de remboursement.",
  "buy-enter-link":
    'Les diamants d\'achat peuvent être rechargés via le lien,<a class="web-link" href="ttps://pay.tadachat.info/" >https://pay.tadachat.info</a> Copiez le lien dans le navigateur sur votre portable pour l\'ouvrir, accédez à la page d\'achat, après avoir vérifié le compte, sélectionnez les spécifications correspondantes et utilisez le mode de paiement approprié pour payer ~ Beaucoup de rabais!',
  "buy-notice-a":
    "Attention: <a>pay.tadachat.info</a> est le seul site officiel d'achat de diamants de Tada",
  replace: "Changer",
  sureBtn: "Oui",
  "pay-style": "Choisissez le mode de paiement",
  goBack: "Retour à la page d'accueil",
  toastTips: "Entrez l'identifiant de Tada ",
  rechargeFAQ_title: "Problèmes communs",
  PayStatusSuccess_title: "Transaction réussie",
  PayStatusFail_title: "Transaction échouée",
  PayStatusCancel_title: "Transaction annulée",
  Diamonds_title: "Site officiel de recharge de diamant de Tada",
  "buy-notice":
    "Remarque pay.Tadachat.info est le seul site officiel d’achat de diamants de Tada, veuillez consulter The Message - Official News - Feedback and Help",
  RechargeHelp_title: "Aide à recharger",
  openAPP: "Ouvrez l'application Tada",
  "buy-diamonds-tit": "Acheter des services de diamants",
  description:
    "Tada est le seul site officiel de recharge de diamants, Tada est un logiciel social international, les utilisateurs de plus de 150 pays et régions du monde utilisent Tada.",
  keywords:
    "Recharge de Tada, recharge de diamant de Tada, recharge officielle de Tada, site officiel de recharge de Tada.",
  payforType: " Méthode de recharge",
  trueText: " Oui",
  falseText: " Annuler",
  alertShowTxt1: " Êtes-vous sûr d'utiliser",
  alertShowTxt3: " pour recharger",
  alertShowTxt5: " diamants?",
  EnterIDTip: "Recharge rapide Tada",
  scanLogin:
    " Pour la confidentialité et la sécurité du compte, veuillez scanner le code pour vous connecter",
  scanTip:
    ' Astuce: Cliquez sur "Analyse" dans le coin supérieur droit de Tada "Centre personnel/Dynamique" pour scanner le code pour vous connecter. En même temps, il prend en charge la connexion en identifiant la capture d\'écran du code QR',
  scanVersion:
    " Veuillez mettre à niveau Tada vers la version %s et scannez le code pour vous connecter",
  delAccount: " Suppression de compte",
  logout: " Déconnexion",
  submit: "Soumettre",
  email_place_holder: "Entrez votre boîte aux lettres",
  contact_email: "Email du contact",
  provide_email:
    "Veuillez fournir votre adresse e-mail pour recevoir une notification de paiement",
  email_address: "Adresse e-mail",
  reseller: "Revendeur",
};



// WEBPACK FOOTER //
// ./src/lang/fr.js